export class ApiError extends Error {
  status: number;
  code?: string;
  details?: unknown;

  constructor(message: string, status: number, code?: string, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

export function getErrorMessage(error: unknown, fallback = 'Something went wrong') {
  if (error instanceof ApiError) return error.message;
  if (typeof error === 'object' && error !== null) {
    const axiosLike = error as {
      response?: { data?: { message?: string } };
      message?: string;
    };
    if (axiosLike.response?.data?.message) return axiosLike.response.data.message;
    if (axiosLike.message) return axiosLike.message;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}
